<template>
  <div>
    <a-form
      ref="genInfoForm"
      :model="info"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row>
        <a-col :span="12">
          <a-form-item name="tplCategory">
            <template #label>
              <span> 生成模板 </span>
            </template>
            <a-select
              v-model:value="info.tplCategory"
              placeholder="请选择"
              @change="tplSelectChange"
            >
              <a-select-option value="crud">单表（增删改查）</a-select-option>
              <a-select-option value="tree">树表（增删改查）</a-select-option>
              <a-select-option value="sub">主子表（增删改查）</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item name="packageName">
            <template #label>
              <span>
                生成包路径
                <a-tooltip>
                  <template #title>
                    生成在哪个java包下，例如 com.ruoyi.system
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-input
              placeholder="请输入生成包路径"
              v-model:value="info.packageName"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item name="moduleName">
            <template #label>
              <span>
                生成模块名
                <a-tooltip>
                  <template #title>
                    可理解为子系统名，例如 url：/xxx/system-user/add 或
                    权限点：xxx:user:edit 或 工程模块：zbtech-xxx-admin
                    中的"xxx"
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-input
              placeholder="请输入生成模块名"
              v-model:value="info.moduleName"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item name="businessName">
            <template #label>
              <span>
                生成业务名
                <a-tooltip>
                  <template #title>
                    可理解为功能英文名，例如 权限点：xxx:user:edit中的"user"
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-input
              placeholder="请输入生成业务名"
              v-model:value="info.businessName"
            />
          </a-form-item>
        </a-col>

        <a-col :span="12">
          <a-form-item name="apiUrlBase">
            <template #label>
              <span>
                生成业务API URL
                <a-tooltip>
                  <template #title>
                    可理解为业务API URL，例如
                    url：/xxx/system-user/add中的"system-user"
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-input
              placeholder="请输入生成业务API URL"
              v-model:value="info.apiUrlBase"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item name="businessPackage">
            <template #label>
              <span>
                生成业务包名
                <a-tooltip>
                  <template #title>
                    可理解为功能包名，例如 com.zbtech.biz.modular.xxx 中的 "xxx"
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-input
              placeholder="请输入生成业务包名"
              v-model:value="info.businessPackage"
            />
          </a-form-item>
        </a-col>

        <a-col :span="12">
          <a-form-item name="functionName">
            <template #label>
              <span>
                生成功能名
                <a-tooltip>
                  <template #title> 用作类描述，例如 用户 </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-input
              placeholder="请输入生成功能名"
              v-model:value="info.functionName"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                上级菜单
                <a-tooltip>
                  <template #title>
                    分配到指定菜单下，例如 系统管理
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-tree-select
              v-model:value="info.parentMenuId"
              :tree-data="menus"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择系统菜单"
              :replaceFields="treeReplaceFields"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                生成代码方式
                <a-tooltip>
                  <template #title>
                    默认为zip压缩包下载，也可以自定义生成路径
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-radio-group v-model:value="info.genType">
              <a-radio :value="'0'">zip压缩包</a-radio>
              <a-radio :value="'1'">生成到工程目录</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12"> </a-col>
      </a-row>
      <a-row v-show="info.tplCategory == 'tree'">
        <a-divider orientation="left"> 其他信息 </a-divider>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                树编码字段
                <a-tooltip>
                  <template #title>
                    树显示的编码字段名， 如：dept_id
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-select v-model:value="info.treeCode" placeholder="请选择">
              <a-select-option
                v-for="(item, index) in info.columns"
                :key="index"
                :value="item.columnName"
              >
                {{ item.columnName + '：' + item.columnComment }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                树父编码字段
                <a-tooltip>
                  <template #title>
                    树显示的父编码字段名， 如：parent_Id
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-select v-model:value="info.treeParentCode" placeholder="请选择">
              <a-select-option
                v-for="(item, index) in info.columns"
                :key="index"
                :value="item.columnName"
              >
                {{ item.columnName + '：' + item.columnComment }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                树名称字段
                <a-tooltip>
                  <template #title>
                    树节点的显示名称字段名， 如：dept_name
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-select v-model:value="info.treeName" placeholder="请选择">
              <a-select-option
                v-for="(item, index) in info.columns"
                :key="index"
                :value="item.columnName"
              >
                {{ item.columnName + '：' + item.columnComment }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 主子表 -->
      <a-row v-show="info.tplCategory == 'sub'">
        <a-divider orientation="left"> 关联信息 </a-divider>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                关联子表的表名
                <a-tooltip>
                  <template #title>
                    关联子表的表名， 如：sys_user
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-select
              v-model:value="info.subTableName"
              placeholder="请选择"
              @change="subSelectChange"
            >
              <a-select-option
                v-for="(item, index) in tables"
                :key="index"
                :value="item.tableName"
              >
                {{ item.tableName + '：' + item.tableComment }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              <span>
                子表关联的外键名
                <a-tooltip>
                  <template #title>
                    子表关联的外键名， 如：user_id
                  </template>
                  <QuestionCircleOutlined />
                </a-tooltip>
              </span>
            </template>
            <a-select v-model:value="info.subTableFkName" placeholder="请选择">
              <a-select-option
                v-for="(item, index) in subColumns"
                :key="index"
                :value="item.columnName"
              >
                {{ item.columnName + '：' + item.columnComment }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script setup>
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { reactive, toRefs, watch } from 'vue'

const props = defineProps({
  info: {
    type: Object,
    default: null,
  },
  tables: {
    type: Array,
    default: null,
  },
  menus: {
    type: Array,
    default: null,
  },
})

const emits = defineEmits(['update:subColumns'])

const state = reactive({
  rules: {
    tplCategory: [{ required: true, message: '请选择生成模板', trigger: 'blur' }],
    packageName: [{ required: true, message: '请输入生成包路径', trigger: 'blur' }],
    moduleName: [{ required: true, message: '请输入生成模块名', trigger: 'blur' }],
    businessName: [{ required: true, message: '请输入生成业务名', trigger: 'blur' }],
    functionName: [{ required: true, message: '请输入生成功能名', trigger: 'blur' }],
    apiUrlBase: [{ required: true, message: '请输入生成业务API URL', trigger: 'blur' }],
    businessPackage: [{ required: true, message: '请输入生成业务包名', trigger: 'blur' }],
  },
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
  treeReplaceFields: {
    children: 'children',
    title: 'menuName',
    key: 'id',
    value: 'id',
  },
  subColumns: [],
})

const { rules, labelCol, wrapperCol, treeReplaceFields, subColumns } = toRefs(state)

watch(
  () => props.info?.subTableName,
  (val) => {
    setSubTableColumns(val)
  }
)

function subSelectChange() {
  if (props.info) props.info.subTableFkName = ''
}

function tplSelectChange(value) {
  if (value !== 'sub' && props.info) {
    props.info.subTableName = ''
    props.info.subTableFkName = ''
  }
}

function setSubTableColumns(value) {
  if (!props.tables || !value) return
  for (const item of props.tables) {
    if (value === item.tableName) {
      subColumns.value = item.columns
      emits('update:subColumns', item.columns)
      break
    }
  }
}
</script>
